import { render, staticRenderFns } from "./citationTraceList.vue?vue&type=template&id=12716f75&scoped=true"
import script from "./citationTraceList.vue?vue&type=script&lang=js"
export * from "./citationTraceList.vue?vue&type=script&lang=js"
import style0 from "./citationTraceList.vue?vue&type=style&index=0&id=12716f75&prod&lang=less&scoped=true"
import style1 from "./citationTraceList.vue?vue&type=style&index=1&id=12716f75&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12716f75",
  null
  
)

export default component.exports